export const GET_SHIPMENT_BY_ID_QUERY = 'GET_SHIPMENT_BY_ID_QUERY';

export type UseShipmentByIdQueryProps = {
  shipmentId?: string;
};
